// extracted by mini-css-extract-plugin
export default {"FooterRightItemContainer":"FooterRightItemContainer_FooterRightItemContainer__FjAVQ"};